module.exports = __webpack_public_path__ + "static/media/HeroFruitSharks.4134b88d.jpg";